import { styled } from "@mui/material"

const MessageError = styled('p')(() => ({
    width: '100%',
    color: 'red',
    display: 'flex',
    margin: 0,
}))

export default MessageError